import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-global-credit-limit-modal',
  templateUrl: './global-credit-limit-modal.component.html',
  standalone: false
})
export class GlobalCreditLimitModalComponent {
  today = new Date();
  @Output() readonly close = new EventEmitter<any>();
  @Output() readonly save = new EventEmitter<any>();
  outstanding: number = 0; // sum of all outstanding balances
  exceededAmountValue = 0;
  currency: any;
  current: any;
  globalCreditLimit:any;
  alreadySavedAmount:any;
  constructor(
    private http: _HttpClient,
    private modalRef: NzModalRef
  ) {
    const instanceData = this.modalRef.getConfig().nzData;
    this.currency = instanceData.currency;
    this.current = instanceData.current;
    this.exceededAmountValue = instanceData.exceededAmount;
    this.outstanding = instanceData.outstanding;
    this.alreadySavedAmount = instanceData.alreadySavedAmount;
    this.globalCreditLimit = instanceData.globalCreditLimit;
  }

 
  closeModal() {
    this.modalRef.close(false);
  }

  saveTransaction() {
    this.modalRef.close(true);
  }


  numberFormatter = (value: number): string => {
    return value
      ? value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      : '0.00';
  };

  numberParser = (value: string): number => {
    return parseFloat(value.replace(/,/g, '')) || 0;
  };
}
